import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { supabase } from '../lib/supabase'

const HEARTBEAT_INTERVAL_MS = 60 * 1000 // 1 раз в минуту

/**
 * Обновляет last_seen_at в profiles, когда пользователь в приложении (/app, /chat).
 * Используется в send-email: если last_seen_at свежий (< 2 мин), письмо new_message не отправляется (считаем онлайн).
 */
export default function LastSeenUpdater() {
  const { user } = useAuth()
  const location = useLocation()
  const intervalRef = useRef(null)

  const isAppRoute = location.pathname.startsWith('/app') || location.pathname.startsWith('/chat')

  const tick = () => {
    if (!user?.id || !isAppRoute) return
    supabase
      .from('profiles')
      .update({ last_seen_at: new Date().toISOString() })
      .eq('id', user.id)
      .then(({ error }) => {
        if (error) console.warn('[LastSeenUpdater]', error.message)
      })
  }

  useEffect(() => {
    if (!user?.id || !isAppRoute) {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
        intervalRef.current = null
      }
      return
    }
    tick()
    intervalRef.current = setInterval(tick, HEARTBEAT_INTERVAL_MS)
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
        intervalRef.current = null
      }
    }
  }, [user?.id, isAppRoute])

  useEffect(() => {
    if (!user?.id || !isAppRoute) return
    const onVisibility = () => {
      if (document.visibilityState === 'visible') tick()
    }
    document.addEventListener('visibilitychange', onVisibility)
    return () => document.removeEventListener('visibilitychange', onVisibility)
  }, [user?.id, isAppRoute])

  return null
}
